import React from 'react'

const ContactMainSection = () => {
  return (
    <>
      <section className="contact-details pt-120 pb-120">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-md-6 col-lg-4 wow fadeInLeft"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <div className="contact-details-block">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={57}
                      height={83}
                      viewBox="0 0 57 83"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M48.2832 67.1208C46.0627 66.0289 43.1956 65.1462 39.887 64.5246C40.8525 63.4943 41.8398 62.3925 42.8295 61.2228C46.7823 56.5509 49.9364 51.7779 52.2042 47.0358C55.0711 41.0411 56.5247 35.0761 56.5247 29.3066C56.5247 13.2934 43.8808 0.265625 28.3395 0.265625C12.7982 0.265625 0.154297 13.2934 0.154297 29.3066C0.154297 35.0761 1.60787 41.0411 4.47478 47.036C6.74259 51.778 9.89667 56.5511 13.8495 61.2229C14.8391 62.3927 15.8265 63.4944 16.792 64.5247C13.4834 65.1464 10.6163 66.0291 8.39581 67.121C4.17257 69.1976 3.28599 71.568 3.28599 73.1907C3.28599 75.2456 4.66534 78.1687 11.2359 80.4255C15.8278 82.0026 21.9018 82.8711 28.3395 82.8711C34.7772 82.8711 40.8512 82.0026 45.4431 80.4255C52.0137 78.1687 53.393 75.2456 53.393 73.1907C53.393 71.568 52.5064 69.1976 48.2832 67.1208ZM3.28599 29.3066C3.28599 15.0726 14.525 3.4924 28.3395 3.4924C42.154 3.4924 53.393 15.0726 53.393 29.3066C53.393 41.2854 46.3901 52.0915 40.5154 59.0475C35.4688 65.0228 30.361 69.2663 28.3395 70.8575C26.3175 69.2658 21.2097 65.0223 16.1637 59.0476C10.2889 52.0915 3.28599 41.2854 3.28599 29.3066ZM44.4527 77.3644C40.1718 78.8345 34.4494 79.6443 28.3395 79.6443C22.2296 79.6443 16.5072 78.8345 12.2263 77.3644C7.93889 75.8919 6.41768 74.1957 6.41768 73.1907C6.41768 71.5146 10.4984 68.6281 19.5449 67.3383C20.8847 68.6503 22.1322 69.7925 23.2223 70.7486C21.5613 71.3399 20.5103 72.2143 20.5103 73.1907C20.5103 74.9735 24.0162 76.4175 28.3395 76.4175C32.6628 76.4175 36.1687 74.9735 36.1687 73.1907C36.1687 72.2143 35.1177 71.3399 33.4567 70.7486C34.5468 69.7925 35.7943 68.6503 37.1341 67.3383C46.1806 68.6281 50.2613 71.5146 50.2613 73.1907C50.2613 74.1957 48.7401 75.8919 44.4527 77.3644Z"
                        fill="#1A4137"
                      />
                      <path
                        d="M50.2655 29.3062C50.2655 16.8515 40.4314 6.71875 28.3437 6.71875C16.256 6.71875 6.42188 16.8515 6.42188 29.3062C6.42188 41.7609 16.256 51.8936 28.3437 51.8936C40.4314 51.8936 50.2655 41.7609 50.2655 29.3062ZM9.55357 29.3062C9.55357 18.6307 17.9828 9.94552 28.3437 9.94552C38.7046 9.94552 47.1338 18.6307 47.1338 29.3062C47.1338 39.9816 38.7046 48.6668 28.3437 48.6668C17.9828 48.6668 9.55357 39.9816 9.55357 29.3062Z"
                        fill="#1A4137"
                      />
                      <path
                        d="M29.9061 40.6012C29.9061 41.4923 30.6071 42.2146 31.4719 42.2146H37.7353C38.6001 42.2146 39.3011 41.4923 39.3011 40.6012V32.5343H42.4328C43.083 32.5343 43.6655 32.1204 43.8964 31.4943C44.1274 30.8681 43.9589 30.16 43.473 29.715L29.3804 16.8079C28.7871 16.2645 27.8932 16.2645 27.2999 16.8079L13.2073 29.715C12.7214 30.16 12.5529 30.8681 12.7839 31.4943C13.0148 32.1204 13.5975 32.5343 14.2476 32.5343H17.3793V40.6012C17.3793 41.4923 18.0803 42.2146 18.9452 42.2146H25.2085C26.0734 42.2146 26.7744 41.4923 26.7744 40.6012V35.761H29.9061V40.6012ZM25.2085 32.5343C24.3437 32.5343 23.6427 33.2566 23.6427 34.1477V38.9878H20.511V30.9209C20.511 30.0298 19.81 29.3075 18.9452 29.3075H18.3661L28.3402 20.1723L38.3144 29.3075H37.7353C36.8705 29.3075 36.1695 30.0298 36.1695 30.9209V38.9878H33.0378V34.1477C33.0378 33.2566 32.3367 32.5343 31.4719 32.5343H25.2085Z"
                        fill="#1A4137"
                      />
                    </svg>
                  </div>
                  <h4 className="title">address line</h4>
                  <p className="text">Jeddah, Saudi Arabia</p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInLeft"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="contact-details-block">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={72}
                      height={80}
                      viewBox="0 0 72 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M56.9976 49.4287C55.5308 47.7285 53.7616 46.8195 51.8865 46.8195C50.0265 46.8195 48.2422 47.7117 46.7149 49.4119L41.9364 54.7144C41.5433 54.4787 41.1501 54.2599 40.7721 54.0411C40.2277 53.7381 39.7136 53.4519 39.275 53.1489C34.799 49.9842 30.7313 45.86 26.8299 40.5238C24.9397 37.8641 23.6695 35.6252 22.7471 33.3527C23.987 32.0902 25.1363 30.7772 26.2553 29.5147C26.6787 29.0433 27.1021 28.5552 27.5255 28.0838C30.7011 24.5488 30.7011 19.9701 27.5255 16.435L23.3973 11.8395C22.9285 11.3177 22.4446 10.779 21.991 10.2403C21.0837 9.19664 20.131 8.1193 19.1481 7.10929C17.6813 5.49327 15.9272 4.63477 14.0824 4.63477C12.2375 4.63477 10.4532 5.49327 8.941 7.10929C8.92588 7.12612 8.92588 7.12612 8.91076 7.14296L3.7694 12.9168C1.83383 15.0715 0.729951 17.6976 0.488005 20.7444C0.125085 25.6598 1.42555 30.2385 2.42358 33.2349C4.87328 40.5911 8.53272 47.4087 13.9916 54.7144C20.6149 63.5183 28.584 70.4706 37.6873 75.3691C41.1652 77.2039 45.8076 79.3755 50.9943 79.7458C51.3119 79.7626 51.6445 79.7795 51.947 79.7795C55.4401 79.7795 58.3737 78.3823 60.6722 75.6048C60.6873 75.5711 60.7175 75.5543 60.7326 75.5206C61.519 74.4601 62.4263 73.5006 63.3789 72.4737C64.0292 71.7836 64.6945 71.0597 65.3447 70.3022C66.8418 68.5684 67.6281 66.5484 67.6281 64.4778C67.6281 62.3905 66.8267 60.3873 65.2994 58.7039L56.9976 49.4287ZM62.4111 67.1544C62.396 67.1544 62.396 67.1712 62.4111 67.1544C61.8214 67.8614 61.2165 68.501 60.5663 69.208C59.5834 70.2517 58.5854 71.3459 57.6478 72.5747C56.1205 74.3928 54.3211 75.2513 51.9621 75.2513C51.7353 75.2513 51.4933 75.2513 51.2665 75.2344C46.7754 74.9146 42.6018 72.9619 39.4716 71.2954C30.9128 66.683 23.3973 60.1348 17.1521 51.8359C11.9956 44.9173 8.54784 38.5206 6.26447 31.6525C4.85816 27.461 4.34402 24.1953 4.57085 21.1148C4.72207 19.1452 5.40254 17.5124 6.65764 16.1152L11.8141 10.375C12.5551 9.60065 13.3414 9.17981 14.1126 9.17981C15.0653 9.17981 15.8365 9.81948 16.3204 10.3582C16.3355 10.375 16.3506 10.3918 16.3657 10.4087C17.2882 11.3682 18.1652 12.3613 19.0876 13.4219C19.5564 13.9605 20.0403 14.4992 20.5242 15.0547L24.6524 19.6502C26.2553 21.4346 26.2553 23.0843 24.6524 24.8686C24.2139 25.3568 23.7905 25.845 23.3519 26.3163C22.0817 27.764 20.872 29.1107 19.5564 30.4237C19.5262 30.4573 19.4959 30.4742 19.4808 30.5078C18.1803 31.9555 18.4223 33.3695 18.6945 34.329C18.7096 34.3795 18.7247 34.43 18.7398 34.4805C19.8135 37.3759 21.3256 40.1029 23.6241 43.3518L23.6392 43.3686C27.8128 49.092 32.2132 53.5529 37.0673 56.9701C37.6873 57.4078 38.3224 57.7613 38.9272 58.0979C39.4716 58.4009 39.9857 58.6871 40.4243 58.9901C40.4848 59.0238 40.5452 59.0743 40.6057 59.108C41.1199 59.3941 41.6038 59.5288 42.1028 59.5288C43.3579 59.5288 44.1442 58.6534 44.4013 58.3673L49.5729 52.6102C50.087 52.0379 50.9036 51.3477 51.8562 51.3477C52.7938 51.3477 53.565 52.0042 54.0338 52.5766C54.0489 52.5934 54.0489 52.5934 54.064 52.6102L62.396 61.8855C63.9536 63.6025 63.9536 65.37 62.4111 67.1544Z"
                        fill="#1A4137"
                      />
                      <path
                        d="M39.0944 18.9945C43.0563 19.7351 46.6552 21.8225 49.5283 25.0209C52.4015 28.2192 54.2614 32.2256 54.9419 36.636C55.1082 37.747 55.9702 38.5213 56.9531 38.5213C57.0741 38.5213 57.1799 38.5045 57.3009 38.4876C58.4199 38.2856 59.1608 37.1073 58.9794 35.8616C58.1628 30.5254 55.8946 25.6605 52.4317 21.8057C48.9688 17.9508 44.5987 15.4258 39.8051 14.5168C38.6861 14.3148 37.6427 15.1396 37.4462 16.3684C37.2496 17.5973 37.9754 18.7925 39.0944 18.9945Z"
                        fill="#1A4137"
                      />
                      <path
                        d="M71.9374 35.2045C70.5915 26.4174 66.8716 18.4215 61.1556 12.0584C55.4396 5.69535 48.2569 1.55431 40.3634 0.0561302C39.2595 -0.162705 38.2161 0.67897 38.0195 1.90781C37.838 3.15349 38.579 4.315 39.698 4.53384C46.7447 5.86369 53.1714 9.58389 58.2825 15.2568C63.3936 20.9465 66.7204 28.1007 67.915 35.9451C68.0813 37.0562 68.9433 37.8305 69.9262 37.8305C70.0471 37.8305 70.153 37.8137 70.274 37.7968C71.3779 37.6117 72.1339 36.4333 71.9374 35.2045Z"
                        fill="#1A4137"
                      />
                    </svg>
                  </div>
                  <h4 className="title">Contact No#</h4>
                  <p className="text">+966 53 589 7085</p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInLeft"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              <div className="contact-details-block">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={81}
                      height={78}
                      viewBox="0 0 81 78"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M79.7591 25.2906L68.2882 16.2709V3.09606C68.1732 1.79097 67.27 0.743483 66.1032 0.5625H15.8503C14.6836 0.743677 13.7803 1.79097 13.6653 3.09606V16.1695L1.73926 25.2904C1.26686 25.6722 0.967667 26.2644 0.919922 26.9119V75.0504C1.07501 76.3716 2.009 77.4115 3.19584 77.5839H78.7577C79.7591 77.5839 80.1233 76.2664 80.1233 75.0504V26.9121C80.1233 26.3039 80.2142 25.6958 79.7591 25.2906ZM68.2882 21.1354L76.1176 27.1146L68.2882 33.7019V21.1354ZM17.3068 4.61628H64.6467V36.8438L40.9767 56.7073L17.3067 36.8438V4.61628H17.3068ZM13.6653 21.0341V33.8036L5.83595 27.1148L13.6653 21.0341ZM4.56146 31.2698L30.0522 52.7548L4.56146 71.9089V31.2698ZM8.93138 73.5304L33.1475 55.3898L39.6112 60.8623C39.9771 61.1772 40.4234 61.3547 40.8857 61.369C41.2499 61.369 41.432 61.1663 41.796 60.8623L48.5328 55.0856L73.0221 73.5304H8.93138ZM76.4818 71.1995L51.5373 52.5521L76.4818 31.2698V71.1995Z"
                        fill="#1A4137"
                      />
                    </svg>
                  </div>
                  <h4 className="title">Mail Adress</h4>
                  <p className="text">info@paic-sa.com</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-100">
            <div className="row g-5">
              <div className="col-lg-6 content-column">
                <div className="inner-column">
                  <div className="sec-title mb-30">
                    <h2 className="title wow splt-txt" data-splitting>
                      Get in touch
                    </h2>
                    <p
                      className="text wow fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      Contact Pak Arab Inspection LTD. CO Company for reliable
                      inspection, testing, calibration, and technical services
                      across Saudi Arabia.
                    </p>
                  </div>
                  <div className="google-map">
                    <iframe
                      src="https://maps.google.com/maps?q=JGWA2554&z=18&output=embed"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 content-column">
                <div className="inner-column right-column">
                  <div className="sec-title mb-30">
                    <h2 className="title wow splt-txt" data-splitting>
                      Fill Up The Form
                    </h2>
                    <p
                      className="text wow fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      Fill out the form below and our team will contact you
                      shortly for your inspection and technical service
                      requirements.
                    </p>
                  </div>
                  <form
                    id="contact_form"
                    name="contact_form"
                    action="includes/sendmail.php"
                    method="post"
                  >
                    <div className="type-feild">
                      <i className="fa-light fa-user" />
                      <input
                        name="form_name"
                        className="required"
                        type="text"
                        placeholder="Your Name*"
                      />
                    </div>
                    <div className="type-feild">
                      <i className="fa-light fa-envelope" />
                      <input
                        name="form_email"
                        className="required"
                        type="email"
                        placeholder="Email Address*"
                      />
                    </div>
                    <div className="type-feild">
                      <i className="fa-light fa-pen-to-square" />
                      <textarea
                        name="form_message"
                        className="required"
                        placeholder="Enter Your Messege here"
                        defaultValue={""}
                      />
                    </div>
                    <button className="btn-two">
                      <i className="fa-light fa-paper-plane" /> Get In Touch
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactMainSection